import React from 'react'
import styles from './Gt2TrustRow.module.css'

// Compact trust row inside the buy box, directly under the product title, so the
// four anxiety-removing facts land ABOVE THE FOLD. The proof band in the left
// column says similar things but sits under the gallery (roughly 1100px down on
// a desktop viewport), and ProductInfoTags sits further down still, just above
// the CTA. This is the at-a-glance version; ProductInfoTags remains the
// expandable detail version next to the price.
//
// Facts only, all already stated elsewhere on the page: EU manufacture, 95%
// pre-assembly, the 3 year warranty on VRS manufactured components, and the
// site-wide 30 day money back guarantee.

const ITEMS = [
  'Designed and made in the EU',
  'Ships 95% pre-assembled',
  '3 year warranty',
  '30 day money back',
]

function Check() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  )
}

function Gt2TrustRow() {
  return (
    <ul className={styles.row} aria-label="Why buy from VRS">
      {ITEMS.map((t) => (
        <li className={styles.item} key={t}>
          <span className={styles.check}><Check/></span>
          <span className={styles.text}>{t}</span>
        </li>
      ))}
    </ul>
  )
}

export default Gt2TrustRow
